import graphql__ae89749dadefc61e7f30 from "./__generated__/MapInformationWindowQuery.graphql.js";import { useEffect, useRef } from "react";
import { graphql } from "react-relay";
import { useDispatch } from "react-redux";
import AppQueryRenderer from "../AppQueryRenderer";

import { useResourcesList } from "../ResourcesList/resourcesList";
import { useMapContext } from "./MapContext";
import MapPanel from "./MapPanel/MapPanel";
import MapElementImage from "./MapElementImage";
import PageSections from "../PageSection/PageSections";
import { selectedItem } from "../Utils/resourcesList";

import { hideInformationWindow } from "../../reducers/map/informationWindow";
import { unselectItem } from "../../reducers/resourcesList/selection";
import Button from "../Buttons/Button";

const MapInformationWindow = props => {
  const { informationWindow } = props;
  const { title, element } = informationWindow;
  const { iconStyle } = element.style || {};

  const { mapKey } = useMapContext();
  const { resourcesListKey } = useResourcesList();
  const dispatch = useDispatch();

  const handleReturnButtonClicked = () => {
    dispatch(hideInformationWindow(mapKey));
    // When the return button is clicked, we also unselect the map item associated to it
    // so it really feels like an actual back button to the user
    dispatch(unselectItem(resourcesListKey));
  };

  return (
    <>
      {title && (
        <div className="map-panel-header map-information-window-title box text-subtitle-page padding-md d-flex align-items-center">
          <Button
            type="button"
            onClick={handleReturnButtonClicked}
            className="btn-unstyled map-panel-btn-return margin-right-md"
            iconClassName="icon-arrow-left map-panel-btn-return-icon"
          />

          <div className="map-information-window-title-wrapper d-flex align-items-center">
            {iconStyle && (
              <div
                className="float-left text-left padding-right-xs"
                dangerouslySetInnerHTML={{
                  __html: MapElementImage({
                    ...iconStyle,
                    width: 40,
                    height: 40,
                    position: "static"
                  })
                }}
              />
            )}

            {title}
          </div>
        </div>
      )}

      <PageSections page={informationWindow} />
    </>
  );
};

const MapInformationWindowManager = props => {
  const resourceList = useResourcesList();
  const selectedResourcesListItem = selectedItem(resourceList);

  const { mapKey } = useMapContext();

  const dispatch = useDispatch();
  const { informationWindowGeometryId } = props;

  const selectedResourcesListItemRef = useRef();

  useEffect(() => {
    if (selectedResourcesListItem && !selectedResourcesListItemRef.current) {
      dispatch(hideInformationWindow(mapKey));
    }
  }, [dispatch, mapKey, selectedResourcesListItem]);

  selectedResourcesListItemRef.current = selectedResourcesListItem;

  return (
    <MapPanel
      className="map-information-window"
      onClose={hideInformationWindow}
      isOpen={true}
      isToggleable={false}
      keepMapVisibleOnOpen={true}
    >
      <AppQueryRenderer
        key={informationWindowGeometryId}
        query={MapInformationWindowQuery}
        variables={{ informationWindowGeometryId }}
        component={MapInformationWindow}
        additionalProps={props}
      />
    </MapPanel>
  );
};

const MapInformationWindowQuery = graphql__ae89749dadefc61e7f30;

export default MapInformationWindowManager;
